/**
 * オンボーディングの段をサーバーに知らせる（2026-10-18 ops/gaps-activity・サーバーは apps/server/src/modules/platform/onboardingSteps.ts・
 * migration 0323 onboarding_steps）。純関数だけ（テストは onboardingSteps.test.ts）。API を呼ぶのは onboardingReport.ts。
 *
 * WHY: 登録してつないでいない人が GTM の段（docs/teams/gtm/onboarding-plan.md §2 の S1〜S6）のどこで止まったかが分からなかった。
 * 送るのは段の名前だけ（画面の中身・コピーした文・入力した文字は送らない）。サーバーは一覧に無い名前を 400 にする。
 * 名前の一覧はサーバーの ONBOARDING_STEPS・migration の CHECK と同じ（サーバーの onboardingSteps.test.ts が突き合わせる = 足すときは 3 か所）。
 *
 * 呼ぶ所:
 *   verify_step_shown / top_up_step_shown / first_ask_shown … pages/HomeC.tsx でその段が開いたとき
 *   connect_guide_opened / connect_command_copied            … pages/HomeParts.tsx ConnectBody（ホームの「つなぐ」の段・使い方ガイド）が文を出した / コピーした
 *   first_ask_copied                                          … pages/HomeC.tsx FirstAsk のコピー
 *   first_test_seen / first_test_played / publish_ask_copied  … pages/HomeC.tsx FirstTestCard が出た / 遊ぶを押した / 公開の文をコピーした
 *
 * 1 画面の読み込みにつき 1 段 1 回まで（同じ段を何度描いても 1 回）。失敗（古いサーバーの 404・ネットワーク）は黙って捨てる = 画面を止めない。
 */

export const ONBOARDING_STEPS = [
  'verify_step_shown',
  'connect_guide_opened',
  'connect_command_copied',
  'top_up_step_shown',
  'first_ask_shown',
  'first_ask_copied',
  'first_test_seen',
  'first_test_played',
  'publish_ask_copied'
] as const;
export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

export const ONBOARDING_STEP_PATH = '/v1/developers/me/onboarding-step';

/** ホームの C の開いた段（homeFlow.ts StepCId）→ 段の名前。「つなぐ」は ConnectBody が自分で知らせる（ガイドの画面でも同じ文を出すため） */
export function stepShownFor(openId: string | undefined): OnboardingStep | null {
  if (openId === 'verify') return 'verify_step_shown';
  if (openId === 'topUp') return 'top_up_step_shown';
  if (openId === 'ask') return 'first_ask_shown';
  return null;
}

/**
 * 知らせる関数を作る。send は API を呼ぶ（onboardingReport.ts）。同じ段は 1 回だけ。
 * send が同期で投げても・Promise が落ちても、呼んだ側（画面）には何も起きない
 */
export function createStepReporter(send: (step: OnboardingStep) => Promise<unknown>): (step: OnboardingStep) => void {
  const sent = new Set<OnboardingStep>();
  return (step) => {
    if (sent.has(step)) return;
    sent.add(step);
    try {
      void Promise.resolve(send(step)).catch(() => undefined);
    } catch {
      // 画面を止めない
    }
  };
}
